export enum EmploymentStatusEnum {
    Empty = 0,
    FullTime = 1,
    PartTime = 2,
    GovernmentTraining = 3,
    JobSeeker = 4,
    Retired = 5,
    NotSeekingWork = 6,
    FullTimeStudent = 7,
    UnableToWork = 8,
    Child = 9,
    SelfEmployed = 10,
    Other = 11,
}
